import './App.css';

const whatsappUrl = 'https://wa.me/6591889109';

const sections = [
  {
    title: 'Lessons',
    text: 'Patient piano study for young musicians.',
    image: '/assets/images/focus.jpg',
  },
  {
    title: 'Performance',
    text: 'Recitals, confidence, and stage craft.',
    image: '/assets/images/recital_2019.jpg',
  },
  {
    title: 'Mastery',
    text: 'A clear path from first notes to expressive playing.',
    image: '/assets/images/steinway.heic',
  },
];

function App() {
  return (
    <main className="site">
      <header className="nav" aria-label="Main navigation">
        <a className="brand" href="#top">The Piano Garden</a>
        <a className="contact-link" href={whatsappUrl} target="_blank" rel="noreferrer">
          WhatsApp
        </a>
      </header>

      <section className="hero" id="top">
        <div className="hero-copy">
          <p className="eyebrow">Singapore piano studio</p>
          <h1>Where music blossoms.</h1>
          <p className="intro">Piano lessons for children, guided with care.</p>
          <a className="button" href={whatsappUrl} target="_blank" rel="noreferrer">
            Enquire
          </a>
        </div>
        <figure className="hero-image">
          <img src="/assets/images/teaching.jpg" alt="A piano lesson at The Piano Garden" />
        </figure>
      </section>

      <section className="statement" aria-label="Studio values">
        <p>Play with grace. Learn with joy. Grow with music.</p>
      </section>

      <section className="sections" aria-label="Highlights">
        {sections.map((section) => (
          <article className="feature" key={section.title}>
            <img src={section.image} alt="" />
            <div>
              <h2>{section.title}</h2>
              <p>{section.text}</p>
            </div>
          </article>
        ))}
      </section>

      <section className="closing">
        <p>New students are welcome.</p>
        <a className="button button-dark" href={whatsappUrl} target="_blank" rel="noreferrer">
          Contact
        </a>
      </section>
    </main>
  );
}

export default App;
